import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useEffect } from "react";
import { useRef } from "react";

import { useFormSubmit } from "./useFormSubmit";
import { useTransformValues } from "./useTransformValues";
import { useAdaptedVehiclesEditFields } from "./useAdaptedVehiclesEditFields";

import { fetchVehiclesEditFields } from "../slices/getVehiclesEditFields";

import { sendForm } from "../slices/sendFormSlice";
import { clearForm } from "../slices/formSlice";
import { updateField } from "../slices/formSlice";

export const useVehiclesEditForm = ({id}) => {
    const dispatch = useDispatch();
    const formId = "vehiclesEditForm";
    const rawEditData = useSelector((state) => state.vehiclesEditFields.data);
    const token = useSelector((state) => state.auth.token);
    const loadingStatus = useSelector((state) => state.sendForm.loadingStatus);
    const error = useSelector((state) => state.sendForm.error);
    const reload = true;
    const { transformFormValues } = useTransformValues();

    useEffect(() => {
        dispatch(fetchVehiclesEditFields({token, id}))
    }, [dispatch, token, id]);

    const adaptedFieldList = useAdaptedVehiclesEditFields();
    const fields = adaptedFieldList.flatMap(category => category.fields);

    const getByPath = (obj, path) => {
        if (!obj || !path) return undefined;

        return path.split('.').reduce((acc, key) => {
            if (acc == null) return undefined;
            return acc[key];
        }, obj);
    };

    const normalizeInitialValue = (field, apiValue) => {
        if (apiValue == null) return apiValue;

        const originalType = field.fieldStructure?.type;

        if (originalType === 'date' && typeof apiValue === 'string') {
            const [datePart] = apiValue.split(' ');
            const [day, month, year] = datePart.split('.');
            if (day && month && year) {
                return `${year}-${month}-${day}`;
            }
        }

        return apiValue;
    };

    const isInitializedRef = useRef(false);

    useEffect(() => {
        if (!rawEditData) return;
        if (!fields.length) return;
        if (isInitializedRef.current) return;

        fields
            .filter((f) => !f.isVirtualSubfield)
            .forEach((field) => {
                const apiRawValue = rawEditData[field.name];
                const apiValue = normalizeInitialValue(field, apiRawValue);

                if (apiValue !== undefined) {
                    dispatch(
                        updateField({
                            formId,
                            fieldName: field.name,
                            value: apiValue,
                        })
                    );
                }
            });

        isInitializedRef.current = true;
    }, [rawEditData, fields, dispatch, formId]);

    const { handleSubmit } = useFormSubmit({
        formId,
        onSubmit: async (formValues) => {
            const attributes = transformFormValues(formValues, fields);

            const body = {
                data: {
                    type: "vehicles",
                    attributes: attributes
                }
            };
            const method= "PUT";

            console.log("Отправляемые данные", body);

            const action = await dispatch(sendForm({url: `/vehicles/${id}`, body, method, token}));
            if (sendForm.fulfilled.match(action)) {
                dispatch(clearForm({formId}));
            } else {
                throw action.payload || action.error
            }
        },
        successMessage: "Успешно отправлено",
        fields,
        reload,
        error
    });

    return { formId, loadingStatus, handleSend: handleSubmit, adaptedFieldList }
}